<script setup>
import Buttons from '@/components/ui/Buttons.vue';
defineProps({
  note: {
    type: Object,
    default: () => {},
  },
  buttons: {
    type: Array,
    default: () => [],
  },
  backgroundColor: {
    type: String,
    default: () => '',
  },
});
</script>

<template>
  <div>
    <div
      v-if="note && (note?.title || note?.value)"
      :class="[
        'insurance-program__note',
        backgroundColor === 'black' ? 'white' : 'black',
      ]"
    >
      <span
        v-if="note?.title"
        class="insurance-program__note-title body-3-bold"
        v-html="note?.title"
      ></span>
      <span
        v-if="note?.value"
        class="insurance-program__note-value body-3-regular"
        v-html="note?.value"
      ></span>
    </div>
    <Buttons
      v-if="buttons && buttons?.length > 0"
      class="insurance-program__buttons"
      :buttons-prefix-class="'js-button-insurance-program'"
      :buttons="buttons"
      :background-color="backgroundColor"
    />
  </div>
</template>
<style scoped lang="scss">
.insurance-program {
  &__note {
    display: flex;
    flex-direction: column;
  }
  &__buttons {
    align-items: flex-start;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    gap: 16px;
    @include media-breakpoint-up(sm) {
      align-items: center;
      gap: 24px;
      flex-direction: row;
    }
    @include media-breakpoint-up(md) {
      margin-top: auto;
    }
    @include media-breakpoint-up(xl) {
      @include responsive-spacing(gap, 24);
    }
  }
}
</style>
